import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  orgDataService,
  authorizationService,
  userService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';
import editUserDialog from '../dialog.editUserDialog';
import editUserCustomerAssignmentsDialog from '../dialog.editUserCustomerAssignments';
import controller from './user.controller';
import directive from './user.directive';


const userAdminModule = angular.module('app.components.admin.user', [
  alerts,
  authorizationService,
  actionIcon,
  confirmDialog,
  editUserDialog,
  editUserCustomerAssignmentsDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('user', directive)
  .controller('UserController', controller);

export default userAdminModule.name;

console.log('app.components.admin.user created');
